import { Component, OnInit } from '@angular/core';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { UserService } from 'src/app/modules/auth/services/user.service';
import { UserInfoService } from '../../../../services/security/user-info.service';
import { MouvementFinancierOutput2, NotificationListerOutput, NotificationService } from '../../../../../../openapi/build';
import { VirementService } from '../../../../budget/validation-virement/service/virement.service';
import { DemandeVirementDC } from '../../../../budget/validation-virement/models/demandeVirement.model';
import { DemandeMouvementComponent } from '../../../../budget/demande-mouvement/demande-mouvement.component';
import { DemandeMouvementSensEnum } from '../../../../budget/demande-mouvement/demande-mouvement-enum';
import { MatDialog } from '@angular/material/dialog';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { MenuProfilComponent } from '../../../../menu/menu-profil/menu-profil.component';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-profil',
    templateUrl: './profil.component.html',
    styleUrls: ['./profil.component.scss'],
    imports: [NgIf, MatIconButton, MatMenuTrigger, MatIcon, MatBadge, MenuProfilComponent, MatMenu, MatDivider, NgFor, MatMenuItem, NgClass]
})
export class ProfilComponent implements OnInit {
  public userProfile: KeycloakProfile | null = null;
  public isLoggedIn = false;
  public profile = '';

  // TODO utliser des paramètres de variables d'environnement
  private previousDate: string = '';

  constructor(
    private readonly keycloak: Keycloak,
    private readonly userService: UserService,
    private readonly userInfoService: UserInfoService,
    private readonly notificationService: NotificationService,
    private readonly virementService: VirementService,
    private readonly dialog: MatDialog
  ) {}

  public notifications: NotificationListerOutput = {};
  public nbNotificationsNonVue = 0;

  public async ngOnInit(): Promise<void> {
    this.isLoggedIn = this.keycloak.authenticated ?? false;
    if (this.isLoggedIn) {
      this.userProfile = await this.keycloak.loadUserProfile();
      // on récupère le libellé du profil depuis le groupe associé dans keycloak
      const profiles = await this.userService.getProfiles();

      // Chargement userInfo service
      await this.userInfoService.loadUserInfo(0, profiles);

      if (profiles) {
        this.profile = profiles.libelle;
      }

      this.relaodNotifications();
    }
  }

  private relaodNotifications(): void {
    this.notificationService.getApiNotificationList().subscribe((notifications: NotificationListerOutput): void => {
      this.notifications = notifications;
      this.nbNotificationsNonVue =
        (this.notifications.mouvement_financier?.length ?? 0) +
        (this.notifications.commande?.length ?? 0) +
        (this.notifications.marches?.length ?? 0);
      console.log('relaodNotifications', this.nbNotificationsNonVue);
    });
  }

  public goToRoute(uuid: string, route: string): void {
    this.notificationService.putApiNotificationsVuePut(uuid).subscribe((): void => {
      window.location.href = route;
    });
  }

  public suppressionNotification(uuid: string): void {
    this.notificationService.putApiNotificationsLuPut(uuid).subscribe((): void => {
      this.relaodNotifications();
    });
  }

  protected showNotificationDate(dateCreation: string): boolean {
    this.previousDate = dateCreation;
    return dateCreation !== this.previousDate;
  }

  afficherDetailVirement(uuidVirement: string, notificationUuid: string): void {
    this.virementService.afficherDemandeVirement(uuidVirement).then((virement: MouvementFinancierOutput2) => {
      const virementDC = virement as DemandeVirementDC;
      return new Promise<DemandeVirementDC[] | boolean>((resolve, reject): Promise<void> => {
        const dialogDetail = this.dialog.open(DemandeMouvementComponent, {
          data: {
            projet: virement.ligneBudgetCible?.projet, // TODO : récupérer projet...
            ligneBudget: virement.ligneBudgetCible,
            virementInterne: virement,
            mode: 'validate',
            type: virement.type,
            sens: DemandeMouvementSensEnum.entrant
          },
          maxWidth: '95%'
        });

        return dialogDetail
          .afterClosed()
          .toPromise()
          .then(
            (result: any): void => {
              if (result !== undefined) {
                if (result === 'valider') {
                  resolve(this.virementService.validerVirements([virementDC]));
                } else if (result === 'refuser') {
                  resolve(this.virementService.refuserVirements([virementDC]));
                } else {
                  resolve(false);
                }
              } else {
                resolve(false);
              }
            },
            (error: any): void => {
              reject(error);
            }
          )
          .then((): void => {
            //attendre le désactivation de la notification avant de recharger les notifications
            setTimeout((): void => {
              this.relaodNotifications();
            }, 2000);
          });
      });
    });
  }
}
